import { render, staticRenderFns } from "./CustDataViewPermissionAdd.vue?vue&type=template&id=39698854"
import script from "./CustDataViewPermissionAdd.vue?vue&type=script&lang=js"
export * from "./CustDataViewPermissionAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports